import { Box, Card, CardContent, CardHeader, ResponsiveCarousel, Skeleton } from '@packages/shared';
import type { ComponentProps, ReactNode } from 'react';

export type RecoCarouselProps = {
  /** Recommendation items */
  children: ReactNode;
  /** Displayed title above the items */
  title: string;
} & ComponentProps<typeof ResponsiveCarousel>;

/**
 * Base component for Product / Category / Brand sliders
 * */
export const RecoCarousel = ({ children, title, loadingState, ...rest }: RecoCarouselProps) => (
  // transform: 'scale(1)' overrides the viewport for display: 'fixed' property of underlying ArrowButton component
  <Box sx={{ transform: 'scale(1)' }}>
    <Card>
      <CardHeader
        title={loadingState ? <Skeleton variant="text" width="15%" /> : title}
        sx={{
          borderBottom: 1,
          borderColor: 'grey.main',
          py: 1,
          px: 2,
        }}
      />
      <CardContent sx={{ p: 2, '.MuiBox-root[data-index]': { overflow: 'visible' } }}>
        <ResponsiveCarousel
          {...rest}
          showDots={false}
          mobile={{ visibleSlides: 2.5, slidesToScroll: 2, gap: 1.5 }}
          tablet={{ visibleSlides: 3.5, slidesToScroll: 3, gap: 1.5 }}
          desktop={{
            visibleSlides: 5.5,
            slidesToScroll: 5,
            gap: 1.5,
          }}
        >
          {children}
        </ResponsiveCarousel>
      </CardContent>
    </Card>
  </Box>
);
